import { CurrencyConverter, IMAGES } from "@/lib/constants";
import {
  ArrowForwardIosRounded,
  InfoOutlined,
  InfoRounded,
  LockOpen,
} from "@mui/icons-material";
import {
  Box,
  Button,
  Grid,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import Image from "next/image";
import styles from "./unlock-offer.module.css";

const UnlockOfferBanner = ({ handleUnlock }) => {
  const theme = useTheme();
  const isBelowMd = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Stack className={styles["unlock-offer"]} sx={{ minWidth: "290px" }}>
      <Grid
        container
        justifyContent={"space-between"}
        paddingTop={{ xs: "10px", md: "20px" }}
        paddingLeft={{ xs: "12px", md: "25px" }}
        sx={{
          // padding: { xs: "5px", md: "10px" },
          // px: { md: "16px" },
          mb: 2,
          cursor: "pointer",
        }}
        onClick={() => handleUnlock()}
      >
        <Grid item xs={6} md={8}>
          <Stack flexDirection={"row"} color={"#fff"}>
            <Box>
              <Typography
                display={"inline"}
                fontWeight={{ xs: 400 }}
                fontSize={{ xs: "12px", md: "20px" }}
              >
                Great News! You’re eligible for up to{" "}
              </Typography>
              <Typography
                display={"inline"}
                fontWeight={{ xs: 700, md: 500 }}
                fontSize={{ xs: "12px", md: "20px" }}
              >
                {isBelowMd ? CurrencyConverter(500000) : `₹ 5,00,000`}
              </Typography>
            </Box>
          </Stack>
          <Button
            sx={{
              backgroundColor: "#fff",
              color: "#004135",
              textTransform: "none",
              fontWeight: 400,
              "&:hover": { backgroundColor: "#004135", color: "#fff" },
              fontSize: { xs: "12px", md: "16px" },
              py: "4px",
              px: "16px",
              marginTop: { xs: isBelowMd ? 1 : 2 },
            }}
            onClick={() => handleUnlock()}
          >
            Avail Now
          </Button>
        </Grid>

        <Grid
          item
          xs={4}
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "flex-end",
          }}
        >
          <Image
            src={IMAGES.moneyGroup}
            alt="Money Sack"
            width={isBelowMd ? 70 : 95}
          />
        </Grid>
      </Grid>
      <Stack
        backgroundColor={"#033A30"}
        alignItems={"center"}
        width="100%"
        sx={{
          borderEndStartRadius: "12px",
          borderEndEndRadius: "12px",
        }}
      >
        <Box
          mt={1}
          display={"flex"}
          flexDirection={"row"}
          gap={0.5}
          alignItems={"center"}
          mb={1}
        >
          <InfoOutlined
            color="#E9FFE6"
            sx={{
              color: "#E9FFE6",
              fontSize: { xs: "12px", md: "14px" },
            }}
          />

          <Typography
            fontWeight={350}
            fontSize={{ xs: "8px", sm: "16px" }}
            color={"#FFFFFF"}
          >
            6 months of Bank statement required
          </Typography>
        </Box>
      </Stack>
    </Stack>
  );
};

//   );
// };

export default UnlockOfferBanner;
